import React from 'react';
import { Icon } from 'ui';

const SelectedFilterBadge = ({ onRemove, children }) => (
  <span className="d-ib p-4-8 bg-blue-lighter bdrs-small c-black fw-b fz-12 f-smooth m-4">
    {children}
    <button type="button" className="u-resetBtn" onClick={onRemove}>
      <Icon name="remove" className="ml-4" />
    </button>
  </span>
);

export default SelectedFilterBadge;
